import React from "react";

const VerifiedButton = () => {

  return (
    <>
      <button
        className="btn btn-light ms-1"
        style={{
          fontSize: "12px",
          backgroundColor: " rgb(220, 252, 231)",
          color: " rgb(122, 175, 159)",
          paddingTop: "3px",
          paddingBottom: "2px",
          marginTop: "0px",
          marginBottom: "0px",
          paddingRight: "2px",
          paddingLeft: "0px",
          width: "76px",
          borderRadius: 0,
          fontFamily: "emoji",
          fontWeight: "700",
        }}
      >
        <i class="bi bi-check-lg"></i> <span className="">Verified</span>
      </button>
    </>
  );
};

export default VerifiedButton;
